<template>
  <transition appear name="slide-fade">
    <div class="administracion-clientes">
      <div class="container">
        <h1 class="administracion-clientes__titulo">Clientes contratados</h1>
        <div class="administracion-clientes__campos mb-3">
          <div class="w-100 administracion-clientes__wrapper-busqueda mt-4">
            <input
              type="text"
              class="form-control administracion-clientes__campo-busqueda"
              placeholder="Buscar un cliente por nombre"
              v-model="textoBusqueda"
            />
            <i
              class="fas fa-search administracion-clientes__icono-busqueda"
            ></i>
          </div>
        </div>
        <div class="d-inline-flex administracion-clientes__campos mb-2 mt-4">
          <label
            class="text-left lead text-light administracion-clientes__etiqueta"
            >Lista de clientes contratados</label
          >
        </div>
        <div class="d-inline-flex administracion-clientes__campos_meses">
          <DropDown
            :disabled="false"
            placeholder="Selecciona un mes para filtrar* "
            :arreglo="meses"
            llave="value"
            valor="value"
            texto="text"
            v-model="mesSeleccionado"
          ></DropDown>
        </div>
        <p class="lead text-light mt-5" v-if="clientesFiltrados.length <= 0">
          {{
            textoBusqueda === ""
              ? "Actualmente tu lista de clientes está vacía"
              : "No se encontraron resultados para tu búsqueda"
          }}
        </p>
        <div class="d-inline-flex administracion-clientes__campos">
          <div class="administracion-clientes__tarjetas w-100 mt-3">
            <TarjetaCliente
              v-for="cliente in clientesFiltrados"
              v-bind:key="cliente.clienteId"
              :prospectoId="cliente.prospectoId"
              :nombreCompleto="cliente.nombreCompleto"
              :monto="cliente.monto"
              :fechaContratacion="cliente.fechaContratacion"
            ></TarjetaCliente>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script lang="js">
// Componentes
import DropDown from "../../Prospecto/components/DropDown.vue"
import TarjetaCliente from "../../Prospecto/components/TarjetaCliente.vue";
//Plugins
import axios from "axios";
//import servicios from '../../../servicios/service.js';

//Rutas API
var rutaCargarClientes = "/api/Master/Contratado/ObtenerClientesContratadosPorJerarquia";

export default {
  name: "AdministracionDeClientes",
  components: {
    DropDown,
    TarjetaCliente
  },
  async mounted() {
      this.CargarClientesContratados();
  },
  data() {
    return {
        textoBusqueda: "",
        meses: [
            {
                value: 1,
                text: "Enero"
            },
            {
                value: 2,
                text: "Febrero"
            },
            {
                value: 3,
                text: "Marzo"
            },
            {
                value: 4,
                text: "Abril"
            },
            {
                value: 5,
                text: "Mayo"
            },
            {
                value: 6,
                text: "Junio"
            },
            {
                value: 7,
                text: "Julio"
            },
            {
                value: 8,
                text: "Agosto"
            },
            {
                value: 9,
                text: "Septiembre"
            },
            {
                value: 10,
                text: "Octubre"
            },
            {
                value: 11,
                text: "Noviembre"
            },
            {
                value: 12,
                text: "Diciembre"
            },
            {
                value: 13,
                text: "Ver todos"
            }
        ],
        mesSeleccionado: 13,
        Clientes:[]
    };
  },
  computed: {
    clientesFiltrados() {
      if(this.textoBusqueda == ""){
          if(this.mesSeleccionado == '13')
              return this.Clientes;
          else {
              return this.Clientes.filter(cliente => cliente.fechaContratacion.substring(5,7).includes(this.mesSeleccionado));
          }
      }
      else {
        let arregloPalabras = this.textoBusqueda.split(/[ ,]+/).filter(f => f.length);
        if(this.mesSeleccionado == 13){
            return this.Clientes.filter(cliente => {
                let nombreCompleto = cliente.nombreCompleto;
                return arregloPalabras.some(p => nombreCompleto.includes(p.toUpperCase()));
            });
        }
        else {
            let clientesFiltradosNombre = this.Clientes.filter(cliente => {
                let nombreCompleto = cliente.nombreCompleto;
                return arregloPalabras.some(p => nombreCompleto.includes(p.toUpperCase()));
            });
            return clientesFiltradosNombre.filter(cliente => cliente.fechaContratacion.substring(5,7).includes(this.mesSeleccionado));
        }
      }
    }
  },
  methods:{
    CargarClientesContratados(){
    axios
        .get(rutaCargarClientes)
        .then((resp) => {
                if (resp.data.estado === 0)
                this.Clientes = resp.data.data;
        })
        .catch((e) => {
                this.ManejarExcepcion(e);
        });
    }
  }
};
</script>

<style scoped>
.administracion-clientes {
  background: url("https://hircasageneral.blob.core.windows.net/embajadores-manager/img/images/img_admon.png") no-repeat
    center center fixed;
  background-size: cover;
  width: 100vw;
  flex-grow: 1;
}
.administracion-clientes__titulo {
  margin-top: 20px;
  color: white;
  font-size: 22px;
  font-weight: bold;
}
.administracion-clientes__campos {
  display: inline-flex;
  width: 50vw;
}
.administracion-clientes__campos_meses {
  display: inline-flex;
  width: 50vw;
  background-color: #ffffff;
}
.administracion-clientes__wrapper-busqueda {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.administracion-clientes__icono-busqueda {
  position: absolute;
  padding-top: 12px;
  padding-right: 12px;
  color: #b8725a;
  font-size: 24px;
  opacity: 0.8;
}

.administracion-clientes__campo-busqueda {
  border-radius: 0px;
  border-style: none;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  letter-spacing: 0.05em;
  height: 50px;
}
.administracion-clientes__etiqueta {
  font-size: 18px;
  font-weight: 500;
}

@media all and (max-width: 767px) {
  .administracion-clientes__campos {
    width: 75vw;
  }
  .administracion-clientes__campos_meses {
    width: 75vw;
    background-color: #ffffff;
  }
  .administracion-clientes__titulo {
    font-size: 20px;
  }
  .administracion-clientes__campo-busqueda {
    font-size: 14px;
  }
  .administracion-clientes__icono-busqueda {
    font-size: 18px;
    padding-top: 16px;
    padding-right: 8px;
    opacity: 0.5;
  }
  .administracion-clientes__etiqueta {
    font-size: 16px;
  }
}
</style>
